import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-345bf6a4"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["textContent"];
export default {
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("h1", {
        class: "guide-title",
        textContent: _toDisplayString(__props.content)
      }, null, 8, _hoisted_1);
    };
  }
};